<mat-card>
  <mat-card-header class="d-flex justify-content-between">
    <mat-card-title>Service Provider Admins</mat-card-title>
    <button mat-raised-button color="primary" (click)="onAddAdminClicked()">
      <mat-icon>add</mat-icon>
      Add Admin
    </button>
  </mat-card-header>

  <mat-card-content>
    <div class="container">
    <table mat-table class="mt-3" [dataSource]="serviceProvider.admins ?? []">
      <ng-container matColumnDef="image">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="p-1">
            <img
              [src]="element.imageUrl"
              alt="Service Provider logo"
              class="rounded-circle"
              width="50"
              height="50"
            />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date Added</th>
        <td mat-cell *matCellDef="let element">
          {{ utils.formatDate(element.createdAt) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.email }}</td>
      </ng-container>

      <!-- <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">todo</td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
    </table>

    @if (!serviceProvider.admins?.length) {
    <div class="text-center mt-2">
      <p>No admins</p>
    </div>
    }
  </div>
  </mat-card-content>
</mat-card>
